const getHiddenAnnotationInput = (img) => {
    const inputId = img.getAttribute("data-field-element");
    if (!inputId) return null;

    const hiddenInput = document.getElementById(inputId);
    if (!hiddenInput) return null;

    return hiddenInput;
};

const getAllAnnotationImages = () =>
    document.querySelectorAll("img[data-field-element]");


renderAnnotationPreviewForImage = (img) => {
    const hiddenInput = getHiddenAnnotationInput(img);
    if (!hiddenInput || !hiddenInput.value) return;

    let parsed;
    try {
        parsed = JSON.parse(hiddenInput.value);
    } catch (e) {
        console.warn("Failed to parse hidden annotation JSON for preview", e);
        return;
    }

    const imageData =
        parsed && parsed.images && parsed.images.length > 0
            ? parsed.images[0]
            : null;

    if (!imageData || !imageData.regions || !imageData.regions.length) {
        return;
    }

    let wrapper = img.parentElement;
    if (!wrapper || !wrapper.classList.contains("annotation-preview-wrapper")) {
        wrapper = document.createElement("div");
        wrapper.className = "annotation-preview-wrapper";
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
    }

    Array.from(wrapper.querySelectorAll(".annotation-preview-box")).forEach(
        (box) => box.remove()
    );

    const width = img.clientWidth;
    const height = img.clientHeight;

    if (!width || !height) {
        img.addEventListener(
            "load",
            function handleLoad() {
                img.removeEventListener("load", handleLoad);
                renderAnnotationPreviewForImage(img);
            },
            { once: true }
        );
        return;
    }

    imageData.regions
        .filter((r) => r.type === "box")
        .forEach((region) => {
            const box = document.createElement("div");
            box.className = "annotation-preview-box";

            const left = region.x * width;
            const top = region.y * height;
            const boxWidth = region.w * width;
            const boxHeight = region.h * height;

            box.style.left = left + "px";
            box.style.top = top + "px";
            box.style.width = boxWidth + "px";
            box.style.height = boxHeight + "px";

            wrapper.appendChild(box);
        });
};

setupAnnotationPreviewObservers = () => {
    const imgs = getAllAnnotationImages();

    imgs.forEach((img) => {
        const hiddenInput = getHiddenAnnotationInput(img);
        if (!hiddenInput) return;

        if (img.dataset.annotationObserverAttached === "true") {
            return;
        }
        img.dataset.annotationObserverAttached = "true";

        renderAnnotationPreviewForImage(img);

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "value"
                ) {
                    renderAnnotationPreviewForImage(img);
                }
            }
        });

        observer.observe(hiddenInput, {
            attributes: true,
            attributeFilter: ["value"],
        });
    });
};

rerenderAllAnnotationPreviews = () => {
    const imgs = getAllAnnotationImages();
    imgs.forEach((img) => renderAnnotationPreviewForImage(img));
};

let annotationPreviewResizeTimeout = null;
handleAnnotationResize = () => {
    if (annotationPreviewResizeTimeout) {
        clearTimeout(annotationPreviewResizeTimeout);
    }
    annotationPreviewResizeTimeout = setTimeout(() => {
        rerenderAllAnnotationPreviews();
    }, 100);
};
